import {
  PROTOCOLO_LOADING, PROTOCOLO_OBTENIDO, PROTOCOLO_ERROR, PROTOCOLO_ITEM_OK,
  REPORTE_LOADING, REPORTE_OBTENIDO, REPORTE_ERROR, REPORTE_ENVIADO,
  REPORTE_ACCION_OK, REPORTE_ACCION_DEL,
  KPIS_LOADING, KPIS_OBTENIDO, KPIS_ERROR,
  DIM3_LOADING, DIM3_OBTENIDO, DIM3_ERROR, DIM3_REGISTRADO, DIM3_RESPONDIDO,
  PROGRESO_LOADING, PROGRESO_OBTENIDO, PROGRESO_ERROR,
} from '../actions/tutoriaHU9Actions';

const initialState = {
  protocolo:        null,
  items:            [],
  porcentaje:       0,
  loadingProtocolo: false,
  reporte:          null,
  acciones:         [],
  infoSesion:       {},
  loadingReporte:   false,
  kpis:             null,
  loadingKpis:      false,
  dim3:             [],
  loadingDim3:      false,
  sesionesProgreso: [],
  resumenProgreso:  null,
  loadingProgreso:  false,
};

export default function tutoriaHU9Reducer(state = initialState, action) {
  switch (action.type) {

    case PROTOCOLO_LOADING:
      return { ...state, loadingProtocolo: true };

    case PROTOCOLO_OBTENIDO:
      return {
        ...state,
        loadingProtocolo: false,
        protocolo:  action.payload.protocolo,
        items:      action.payload.items,
        porcentaje: action.payload.porcentaje,
      };

    case PROTOCOLO_ERROR:
      return { ...state, loadingProtocolo: false };

    case PROTOCOLO_ITEM_OK: {
      const { idDetalle, data, estado_protocolo } = action.payload;
      const items = state.items.map(item =>
        item.id_detalle === idDetalle ? { ...item, ...data } : item
      );
      const total    = items.length;
      const cumplidos = items.filter(i => ['cumplido', 'cumplido_tarde'].includes(i.estado)).length;
      const porcentaje = total > 0 ? Math.round((cumplidos / total) * 100) : 0;
      return {
        ...state,
        items,
        porcentaje,
        protocolo: { ...state.protocolo, estado: estado_protocolo }
      };
    }

    case REPORTE_LOADING:
      return { ...state, loadingReporte: true };

    case REPORTE_OBTENIDO:
      return {
        ...state,
        loadingReporte: false,
        reporte:     action.payload.reporte,
        acciones:    action.payload.acciones,
        infoSesion:  action.payload.info_sesion || {},
      };

    case REPORTE_ERROR:
      return { ...state, loadingReporte: false };

    case REPORTE_ENVIADO:
      return {
        ...state,
        reporte: { ...state.reporte, estado: 'enviado', bloqueado: 1, fecha_envio: action.payload }
      };

    case REPORTE_ACCION_OK:
      return { ...state, acciones: [...state.acciones, action.payload] };

    case REPORTE_ACCION_DEL:
      return { ...state, acciones: state.acciones.filter(a => String(a.id_accion) !== String(action.payload)) };

    case KPIS_LOADING:
      return { ...state, loadingKpis: true };
    case KPIS_OBTENIDO:
      return { ...state, loadingKpis: false, kpis: action.payload };
    case KPIS_ERROR:
      return { ...state, loadingKpis: false };

    case DIM3_LOADING:
      return { ...state, loadingDim3: true };
    case DIM3_OBTENIDO:
      return { ...state, loadingDim3: false, dim3: action.payload };
    case DIM3_ERROR:
      return { ...state, loadingDim3: false };
    case DIM3_REGISTRADO:
      return { ...state, dim3: [action.payload, ...state.dim3] };
    case DIM3_RESPONDIDO: {
      const { id_seguimiento, fecha_accion, resuelto_tiempo } = action.payload;
      return {
        ...state,
        dim3: state.dim3.map(c =>
          String(c.id_seguimiento) === String(id_seguimiento)
            ? { ...c, fecha_accion, resuelto_tiempo }
            : c
        ),
      };
    }

    case PROGRESO_LOADING:
      return { ...state, loadingProgreso: true };
    case PROGRESO_OBTENIDO:
      return {
        ...state,
        loadingProgreso:  false,
        sesionesProgreso: action.payload.sesiones,
        resumenProgreso:  action.payload.resumen,
      };
    case PROGRESO_ERROR:
      return { ...state, loadingProgreso: false };

    default:
      return state;
  }
}
